import {
    NinchatEmbedConfig, NinchatEnvironmentConfig,
} from 'embed/types'

import {EmbedEvents} from 'embed/types/events'
import {StrictMap} from 'types'
import {UnsubscribeListener} from '@reduxjs/toolkit'
import {start as startAudience} from 'embed/listeners/audience'
import {start as startChannel} from 'embed/listeners/channel'
import {start as startMembers} from 'embed/listeners/members'
import {start as startNavigation} from 'embed/listeners/navigation'
import {start as startQueue} from 'embed/listeners/queue'
import {start as startSession} from 'embed/listeners/session'

export const config: StrictMap<NinchatEmbedConfig> = new Map()

const unsubscribeListeners: UnsubscribeListener[] = []

type Entry = [keyof NinchatEmbedConfig, NinchatEmbedConfig[keyof NinchatEmbedConfig]]

export const listeners = {
    start: (arg: NinchatEmbedConfig, sendToParent: (event: EmbedEvents) => void, conf: NinchatEnvironmentConfig) => {
        Object.entries(arg).forEach((e) => config.set(...e as Entry))

        unsubscribeListeners.push(...startAudience(sendToParent, conf))
        unsubscribeListeners.push(...startNavigation(sendToParent, conf))
        unsubscribeListeners.push(...startQueue(sendToParent))
        unsubscribeListeners.push(...startSession(sendToParent))
        unsubscribeListeners.push(...startChannel(conf, sendToParent))
        unsubscribeListeners.push(...startMembers(sendToParent))
    },
    stop: () => {
        while (unsubscribeListeners.length) {
            (unsubscribeListeners.pop() as UnsubscribeListener)() // eslint-disable-line no-extra-parens
        }
    },
}
